var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"header"}},[_vm._m(0),_c('KnowledgeBaseContainers')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"text-center"},[_vm._v("Baza wiedzy")]),_c('h3',{staticClass:"text-center"},[_vm._v(" Praktyczne materiały, nagrania, porady ekspertów HR "),_c('br'),_vm._v("zebrane dla Ciebie w jednym miejscu ")])])
}]

export { render, staticRenderFns }